import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  appFontColor,
  mediumFont,
  regularFont,
  primaryColor,
} from '@app/styles';
import Logo from '@app/assets/images/munitechlogo.png';

type ContainerProps = {
  disabled?: boolean;
};

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: 80px;
  width: 100%;
  overflow: hidden;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const InnerContainer = styled.div`
  width: 100%;
  padding: 15px;
  position: relative;
  height: calc(100vh - 65px);
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    padding: 85px 0 0px;
    width: 500px;
    height: 450px;
    display: flex;
    margin: 50px auto;
    flex-direction: column;
    background: ${whiteColor};
    box-shadow: rgb(100 112 119 / 20%) 0px 5px 10px 0px;
    border-radius: 8px;
    input {
      border-color: #ccc;
    }
  }
`;
export const Row = styled.div`
  width: 100%;

  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    padding: 15px 15px 0;
  }
`;
export const RowItem = styled.div`
  width: 100%;
  position: relative;
  margin: 25px 0;
  @media (${screenSize.tablet}) {
    width: 400px;
    padding: 0 15px;
    margin: 0;
  }
`;
export const Heading = styled.div`
  color: ${appFontColor};
  text-align: center;
  padding: 15px 15px 0;
  font-size: 21px;
  margin-top: 20px;
  ${mediumFont};
  @media (${screenSize.tablet}) {
    padding: 15px;
    margin-top: 0px;
    border-bottom: 2px solid #dce0e8;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Footer = styled.div`
  width: 100%;
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (${screenSize.tablet}) {
    border-top: 1px solid #bdc3c7;
    padding: 0 10px;
    height: 90px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;
export const ButtonContainer = styled.div`
 width: 50%;
 button {
    height: 50px;
  }
  ${({ disabled }: ContainerProps) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    width: 165px;
  }
`;
export const CancelButton = styled.div`
  margin-right: 15px;
  cursor: pointer;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Rule = styled.p`
  color: #424750;
  font-size: 13px;
  line-height: 17px;
  margin: 20px 0 0;
  padding: 0;
  display: flex;
  @media (${screenSize.tablet}) {
    padding: 0 30px;
    border-top: 0;
    margin: 10px 0;
  }
`;

export const ErrorMessage = styled.p`
  font-size: 14px;
  ${regularFont};
  color: #ec4160;
  margin: 0;
  position: absolute;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;
export const SavingIndicator = styled.div`
  position: absolute;
  right: 30px;
  top: 35px;
  svg {
    path {
      fill: ${primaryColor};
    }
  }
  @media (${screenSize.tablet}) {
    left: 30px;
    right: auto;
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;

export const IntroText = styled.p`
  top: 14%;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 18px;
  color: #3a435e;
  ${regularFont}
  margin-bottom: 20px;
  @media (${screenSize.tablet}) {
    position: relative;
    top: auto;
    padding: 0;
  }
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;
